import { ERROR_CODES } from '@/consts';

export default class ConfirmPasswordNotMatch extends Error {
  static code = ERROR_CODES.AUTH_CONFIRM_PASSWORD_NOT_MATCH;

  constructor(message) {
    super(message || 'Confirm password not match with New password.');
    this.code = ERROR_CODES.AUTH_CONFIRM_PASSWORD_NOT_MATCH;
  }
}
